module.exports = __webpack_public_path__ + "static/media/taxa2.e5229810.png";